module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_JCKSummitIntro2019_v1.42bad421.jpg";